/* KÖRA Cápsulas — JS compartido entre secciones.
   Config dependiente de Liquid (variant IDs, textos) se inyecta por sección
   vía window.KORA_CTA_CONFIG antes de que este archivo corra. */

function pAddToCart(btn) {
  var cfg = window.KORA_CTA_CONFIG || {};
  var varIdInput = document.getElementById('p-variant-id')
    || document.getElementById('p-variant-id-bottom')
    || document.getElementById('p-variant-id-sticky');
  var id = cfg.varId || (varIdInput ? varIdInput.value : '');

  if (!id) {
    console.warn('[KÖRA] Sin ID de variante activa.');
    if (btn) btn.textContent = 'Error de variante';
    return;
  }

  if (cfg.dest === 'url') {
    window.location.href = cfg.urlCustom || '/';
    return;
  }

  var originalText = btn ? btn.textContent : '';
  if (btn) {
    btn.disabled = true;
    btn.textContent = 'Procesando...';
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
  })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) {
        if (btn) { btn.disabled = false; btn.textContent = cfg.texto || originalText; }
        alert(data.description || 'No se pudo agregar al carrito.');
        return;
      }
      // Redirige al carrito
      window.location.href = '/cart';
    })
    .catch(function (err) {
      console.error(err);
      if (btn) { btn.disabled = false; btn.textContent = cfg.texto || originalText; }
      alert('Error de conexión. Intentá de nuevo.');
    });
}

function pClosePopup() {
  var overlay = document.getElementById('p-popup-overlay');
  if (overlay) overlay.classList.remove('visible');
}

function pSubmitEmail() {
  var input = document.getElementById('p-popup-email');
  var email = input ? input.value.trim() : '';
  var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!email || !emailRegex.test(email)) {
    if (input) {
      input.style.borderColor = '#8B5E3C';
      input.focus();
    }
    return;
  }
  var step1 = document.getElementById('p-popup-step1');
  var step2 = document.getElementById('p-popup-step2');
  if (step1) step1.style.display = 'none';
  if (step2) step2.style.display = 'block';
  localStorage.setItem('pPopupShown', '1');
}

function pCopyCode() {
  var code = (window.KORA_POPUP_CONFIG && window.KORA_POPUP_CONFIG.code) || 'KORA5';
  var btn = document.getElementById('p-popup-copy-btn');
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(code).then(function () {
      if (btn) { btn.textContent = '¡Copiado!'; setTimeout(function () { btn.textContent = 'Copiar'; }, 2000); }
    });
  } else {
    var el = document.getElementById('p-popup-code');
    if (el) {
      var range = document.createRange();
      range.selectNodeContents(el);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
    }
    if (btn) { btn.textContent = '¡Copiado!'; setTimeout(function () { btn.textContent = 'Copiar'; }, 2000); }
  }
}

function pPlayVid(overlay) {
  var wrap = overlay.parentElement;
  var video = wrap.querySelector('.p-vtesti-mp4');
  if (!video) return;
  overlay.style.display = 'none';
  video.controls = true;
  video.play();
}

function pChangeImg(src, el) {
  var mainImg = document.getElementById('p-main-img');
  if (mainImg) mainImg.src = src;
  document.querySelectorAll('.p-gallery-thumb').forEach(function (t) { t.classList.remove('active'); });
  if (el) el.classList.add('active');
}

function pToggleFaq(btn) {
  var item = btn.closest('.p-faq-item');
  var wasOpen = item.classList.contains('open');
  document.querySelectorAll('.p-faq-item').forEach(function (i) { i.classList.remove('open'); });
  if (!wasOpen) item.classList.add('open');
}

var pCarouselOffset = 0;
function pCarouselMove(dir) {
  var track = document.getElementById('pPhotosTrack');
  if (!track) return;
  var cardWidth = 170 + 12;
  pCarouselOffset += dir * cardWidth;
  var totalWidth = track.scrollWidth / 2;
  if (pCarouselOffset >= totalWidth) pCarouselOffset = 0;
  if (pCarouselOffset < 0) pCarouselOffset = totalWidth - cardWidth;
  track.style.animationPlayState = 'paused';
  track.style.transform = 'translateX(-' + pCarouselOffset + 'px)';
  track.style.transition = 'transform 0.4s ease';
}

function initKORA() {
  // Touch para la galería principal
  var galleryMain = document.querySelector('.p-gallery-main');
  if (galleryMain) {
    var touchStartX = 0;
    galleryMain.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    galleryMain.addEventListener('touchend', function (e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) < 50) return;
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('.p-gallery-thumb'));
      var activeIdx = thumbs.findIndex(function (t) { return t.classList.contains('active'); });
      if (activeIdx === -1) activeIdx = 0;
      var nextIdx = diff > 0 ? Math.min(activeIdx + 1, thumbs.length - 1) : Math.max(activeIdx - 1, 0);
      if (nextIdx !== activeIdx && thumbs[nextIdx]) thumbs[nextIdx].click();
    }, { passive: true });
  }

  // Contadores animados
  var counters = document.querySelectorAll('.p-stat-num[data-target]');
  var countDone = false;
  if (counters.length) {
    var statsObserver = new IntersectionObserver(function (entries) {
      if (countDone) return;
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          countDone = true;
          counters.forEach(function (el) {
            var targetStr = el.getAttribute('data-target');
            var target = parseFloat(targetStr);
            var isDecimal = targetStr.includes('.');
            var suffix = el.getAttribute('data-suffix') || '';
            var duration = 1800;
            var startTime = null;

            function step(timestamp) {
              if (!startTime) startTime = timestamp;
              var progress = Math.min((timestamp - startTime) / duration, 1);
              var eased = 1 - Math.pow(1 - progress, 3);
              var currentNum = eased * target;
              
              if (isDecimal) {
                el.textContent = currentNum.toFixed(1) + suffix;
              } else {
                el.textContent = Math.floor(currentNum) + suffix;
              }
              
              if (progress < 1) requestAnimationFrame(step);
            }
            requestAnimationFrame(step);
          });
        }
      });
    }, { threshold: 0.3 });

    statsObserver.observe(counters[0].closest('.p-section') || counters[0]);
  }

  // Sticky bar
  var sticky = document.getElementById('p-sticky');
  var stickyBtn = document.getElementById('p-sticky-btn');
  var threshold = 500;

  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () { pAddToCart(stickyBtn); });
  }

  window.addEventListener('scroll', function () {
    if (sticky) sticky.classList.toggle('visible', window.scrollY > threshold);
  }, { passive: true });

  // Slider antes/después
  var slider = document.getElementById('pBaSlider');
  if (slider) {
    var afterImg = slider.querySelector('.p-ba-img--after');
    var handle = slider.querySelector('.p-ba-handle');
    if (afterImg && handle) {
      var dragging = false;
      var applyPct = function (p) {
        afterImg.style.clipPath = 'inset(0 ' + (100 - p) + '% 0 0)';
        handle.style.left = p + '%';
      };
      var getPct = function (clientX) {
        var r = slider.getBoundingClientRect();
        return Math.max(5, Math.min(95, (clientX - r.left) / r.width * 100));
      };
      var cx = function (e) { return e.touches ? e.touches[0].clientX : e.clientX; };

      slider.addEventListener('mousedown', function (e) { dragging = true; applyPct(getPct(cx(e))); });
      slider.addEventListener('touchstart', function (e) { dragging = true; applyPct(getPct(cx(e))); }, { passive: true });
      window.addEventListener('mousemove', function (e) { if (dragging) applyPct(getPct(cx(e))); });
      window.addEventListener('touchmove', function (e) { if (dragging) applyPct(getPct(cx(e))); }, { passive: true });
      window.addEventListener('mouseup', function () { dragging = false; });
      window.addEventListener('touchend', function () { dragging = false; });
    }
  }

  // Popup de salida
  var overlay = document.getElementById('p-popup-overlay');
  if (overlay) {
    var showPopup = function () {
      if (!sessionStorage.getItem('popupShown')) {
        sessionStorage.setItem('popupShown', '1');
        overlay.classList.add('visible');
      }
    };
    if (window.innerWidth > 768) {
      document.addEventListener('mouseleave', function (e) { if (e.clientY <= 0) showPopup(); });
    } else {
      setTimeout(showPopup, 30000);
    }
  }

  initKoraCuotas();
}

/* Card de cuotas */
function initKoraCuotas() {
  var wrapper = document.querySelector('.kora-kaching-wrapper');
  var montoEl = document.getElementById('p-cuota-monto');
  if (!wrapper || !montoEl) return;

  var KACHING_SELECTED_SELECTOR = '[aria-selected="true"], [data-selected="true"], .selected, [class*="selected"]';

  function getValidText(el) {
    var text = "";
    if (!el) return text;
    for (var i = 0; i < el.childNodes.length; i++) {
      var node = el.childNodes[i];
      if (node.nodeType === 3) {
        text += node.nodeValue + " ";
      } else if (node.nodeType === 1) {
        var style = window.getComputedStyle(node);
        if (style.textDecoration.indexOf('line-through') !== -1 || node.tagName === 'S' || node.tagName === 'STRIKE' || node.tagName === 'DEL' || style.display === 'none' || style.opacity === '0') {
          continue;
        }
        text += getValidText(node) + " ";
      }
    }
    return text;
  }

  function parsePriceFromText(text) {
    if (!text) return null;
    var matches = text.match(/\$\s?[\d.,]+/g);
    if (!matches || !matches.length) return null;
    
    var nums = matches.map(function (m) {
      var clean = m.replace('$', '').trim();
      clean = clean.replace(/[,.]00$/, ''); 
      clean = clean.replace(/[.,]/g, '');   
      return parseInt(clean, 10);
    }).filter(function (n) { return !isNaN(n) && n > 0; });

    if (!nums.length) return null;
    return Math.max.apply(null, nums);
  }

  function fmtARS(n) {
    return '$' + Math.round(n).toLocaleString('es-AR');
  }

  var lastValue = null;
  function updateCuotas() {
    var selected = wrapper.querySelector(KACHING_SELECTED_SELECTOR);
    var activeContainer = selected ? selected : wrapper;
    
    var validText = getValidText(activeContainer);
    var price = parsePriceFromText(validText);
    
    if (price == null) return;

    var val = fmtARS(price / 3);
    if (val === lastValue) return;
    lastValue = val;

    montoEl.classList.add('p-cuotas-updating');
    setTimeout(function () {
      montoEl.textContent = val;
      montoEl.classList.remove('p-cuotas-updating');
    }, 150);
  }

  var observer = new MutationObserver(function () {
    clearTimeout(window._koraCuotasDebounce);
    window._koraCuotasDebounce = setTimeout(updateCuotas, 150);
  });
  observer.observe(wrapper, { childList: true, subtree: true, characterData: true });

  setTimeout(updateCuotas, 800);
  setTimeout(updateCuotas, 2000);
}

if ('requestIdleCallback' in window) {
  requestIdleCallback(initKORA, { timeout: 2000 });
} else {
  setTimeout(initKORA, 200);
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('video[poster=""]').forEach(function (video) {
    video.addEventListener('loadeddata', function () {
      var canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext('2d').drawImage(video, 0, 0);
      video.poster = canvas.toDataURL();
    });
  });
});

/* Notificaciones de visitantes (kora-caps-visitor-notification) */
(function () {
  function boot() {
    var el = document.getElementById('kora-visitor-notification');
    var textEl = el ? el.querySelector('.kora-visitor-notif__text') : null;
    if (!el || !textEl) return;

    var notifications = window.KORA_NOTIFICATIONS && window.KORA_NOTIFICATIONS.length
      ? window.KORA_NOTIFICATIONS
      : [
        "🛍️ <strong>Valentina</strong> de Buenos Aires compró hace 3 min",
        "👀 <strong>23 personas</strong> están viendo este producto",
        "✅ <strong>Sofía</strong> de La Plata acaba de comprar"
      ];

    // Variables que vienen del bloque Liquid, con fallbacks de seguridad.
    var speed = window.KORA_NOTIF_SPEED || 5000;  // Tiempo visible (ej. 5 seg)
    var pause = window.KORA_NOTIF_PAUSE || 15000; // Pausa (ej. 15 seg)

    var currentIndex = Math.floor(Math.random() * notifications.length);
    var isShowing = false; // Candado para evitar superposiciones

    function showNotification() {
      if (isShowing) return; 
      isShowing = true;

      textEl.innerHTML = notifications[currentIndex];
      el.classList.add('visible');
      currentIndex = (currentIndex + 1) % notifications.length;

      // Ocultar después del tiempo establecido
      setTimeout(function () {
        el.classList.remove('visible');
        isShowing = false;
      }, speed);
    }

    function scheduleNext() {
      // Sumamos 'speed' + 'pause' para que la cuenta regresiva 
      // empiece DESPUÉS de que la notificación desapareció
      setTimeout(function () {
        showNotification();
        scheduleNext();
      }, speed + pause); 
    }

    // Mostrar la primera notificación a los 3 segundos de entrar a la web
    setTimeout(function () {
      showNotification();
      scheduleNext();
    }, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();